import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import './registerServiceWorker'
//import router from './router'
import store from './store'
import moment from 'vue-moment'
import VueSwal from 'vue-swal'
import vSelect from 'vue-select'

import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false

Vue.use(VueSwal)
Vue.use(moment)

Vue.component('v-select', vSelect)

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
